/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Report_PlaceholderInputs */

const en_kindle_report_placeholder = /** @type {(inputs: Kindle_Report_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happened while you were listening?`)
};

const es_kindle_report_placeholder = /** @type {(inputs: Kindle_Report_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasó mientras escuchabas?`)
};

/**
* | output |
* | --- |
* | "What happened while you were listening?" |
*
* @param {Kindle_Report_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_report_placeholder = /** @type {((inputs?: Kindle_Report_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Report_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_report_placeholder(inputs)
	return en_kindle_report_placeholder(inputs)
});